import Autolinker from 'autolinker';

const { origin } = window.location;
const isLinkSameOrigin = url => url.includes(origin);
const autolinkerOptions = {
  stripPrefix: false,
  stripTrailingSlash: false,
  truncate: { length: 32, location: 'middle' },
  newWindow: false,
};

function handleAttributes(link) {
  if (isLinkSameOrigin(link.href)) {
    link.removeAttribute('target');
    link.removeAttribute('rel');
    return;
  }

  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
}

// Sets attribute 'target' and 'rel' for all links that are not on same origin
function setLinkAttributes(content) {
  const el = document.createElement('div');
  el.innerHTML = content;
  el.querySelectorAll('a').forEach(link => handleAttributes(link));
  return el.innerHTML;
}

function autolinkAndSetTarget(content, options) {
  return setLinkAttributes(
    Autolinker.link(
      content,
      options === undefined ? autolinkerOptions : options
    )
  );
}

export default autolinkAndSetTarget;
